export default {
    props: {
        filter: {
            type: Object,
            required: true
        },
        fKey: {
            type: String,
            required: true
        }
    }
}